module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fimark"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMark.show),
      expression: "isMark.show"
    }],
    staticClass: "list-mark"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "list-icon",
    on: {
      "click": _vm.hideMark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-icon"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "link-list"
  }, [_c('li', {
    on: {
      "click": _vm.listHandle
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'flatindexmobile'
      }
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.listHandle
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'aboutusmobile'
      }
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.listHandle
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'cooperatemobile'
      }
    }
  }, [_vm._v("商务合作")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.listHandle
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'helpcentermobile'
      }
    }
  }, [_vm._v("帮助中心")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48615b88"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fimark/index.vue
// module id = 340
// module chunks = 1